import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.practitioner-safe-presenter': {
         MEDICAL_LICENCE_NUMBER: 'NPWZ',
         PESEL: 'PESEL',
         noSpecialties: 'brak specjalizacji',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.practitioner-safe-presenter'
);
